WiseMetering.Collection.OrganizationLogs = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.OrganizationLog,
    url: '/organization_logs',
    comparator: function(model) {
        return -model.get('created_at');
    }
});
